import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCandidatePredictionIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#f8f",
	...props,
	children: /* @__PURE__ */ _jsx("rect", {
		height: "100%",
		width: "100%",
		fill: "currentColor"
	})
});
export default SvgCandidatePredictionIcon;
